import { render, staticRenderFns } from "./PopupIdentityMismatch.vue?vue&type=template&id=8384a932&scoped=true&lang=pug"
import script from "./PopupIdentityMismatch.vue?vue&type=script&lang=ts"
export * from "./PopupIdentityMismatch.vue?vue&type=script&lang=ts"
import style0 from "./PopupIdentityMismatch.vue?vue&type=style&index=0&id=8384a932&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8384a932",
  null
  
)

export default component.exports